import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-transparent">
        <div className="text-ink-muted font-heading text-sm">Verifying session…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    if (user.role === "startup") return <Navigate to="/startup/dashboard" replace />;
    if (user.role === "investor") return <Navigate to="/investor/dashboard" replace />;
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
}
